/**
 * The wording currently published at /privacy and /disclaimer.
 *
 * Sent with a registration so the account records which version was accepted, and must match
 * AuthService.CURRENT_TERMS_VERSION on the server. Bump both when either document changes
 * materially.
 */
export const TERMS_VERSION = '2026-10-04'
